import React from 'react';
import Styles from './NotificationBadge.module.scss';

const NotificationBadge = (props) => {
  const {
    isOpen, setNotificationMessageOpen, message,
  } = props;

  if (!isOpen) {
    return false;
  }

  return (
    <div
      className={Styles.notificationBadge}
      onClick={() => setNotificationMessageOpen(false)}
    >
      <div className={Styles.message}>
        {message?.icon && (
          <img
            className={Styles.notificationIcon}
            src={message.icon} alt='icon'
          />
        )}
        {message?.text}
      </div>
    </div>
  );
};

export default NotificationBadge;
